<template>
  <b-row>
    <b-col v-if="!tableDetail">
      <b-card no-body>
        <div slot="header">
          <div v-html="caption" class="float-left"></div>
          <div class="float-right">
            <b-button
              size="sm"
              v-if="uploadByExcell"
              v-on:click.prevent="addFormExcell($event.target)"
              variant="stack-overflow"
              class="mr-1 btn-brand"
            >
              <i class="fa fa-upload"></i>
              <span>{{ addExcellButton }}</span>
            </b-button>

            <b-button
              size="sm"
              v-if="generateAutoSpkb"
              v-on:click.prevent="generateSPKB($event.target)"
              variant="stack-overflow"
              class="mr-1 btn-brand"
            >
              <i class="fa fa-gear"></i>
              <span>Generate SPKB</span>
            </b-button>

            <b-button
              size="sm"
              v-if="showAddButton"
              v-on:click.prevent="addForm($event.target)"
              variant="stack-overflow"
              class="mr-1 btn-brand float-right"
            >
              <i class="fa fa-plus"></i>
              <span>{{ addButton }}</span>
            </b-button>
          </div>
        </div>

        <b-card-body>
          <b-row>
            <b-col>
              <b-form id="filterForm">
                <b-row>
                  <b-col sm="3">
                    <b-form-group>
                      <b-form-input
                        v-model="filter"
                        placeholder="Searching"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </b-col>
            <b-col lg="12">
              <div v-if="!loading">
                <b-table
                  :filter="filter"
                  :dark="dark"
                  :hover="hover"
                  :striped="striped"
                  :bordered="bordered"
                  :small="small"
                  :fixed="fixed"
                  responsive="sm"
                  :items="items"
                  :fields="captions"
                  head-variant="light"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :show-empty="true"
                  :redirect-detail="redirectDetail"
                  @filtered="onFiltered"
                >
                  <template v-slot:cell(date)="data">
                    <div v-if="data.item.date" v-html="dateFormat(data.item.date)"></div>
                  </template>

                  <template v-slot:cell(date_inserted)="data">
                    <div
                      v-if="data.item.date_inserted"
                      v-html="dateFormat(data.item.date_inserted)"
                    ></div>
                  </template>

                  <template v-slot:cell(process_time)="data">
                    <div
                      v-if="data.item.process_time"
                      v-html="dateFormat(data.item.process_time)"
                    ></div>
                  </template>

                  <template v-slot:cell(attendance_history_date)="data">
                    <div v-html="dateTimeFormat(data.item.attendance_history_date)"></div>
                  </template>

                   <template v-slot:cell(date_updated)="data">
                    <div v-html="dateTimeFormat(data.item.date_updated)"></div>
                  </template>

                  <template v-slot:cell(plan_delivery_order)="data">
                    <div v-html="dateFormat(data.item.plan_delivery_order)"></div>
                  </template>

                  <template v-slot:cell(date_order)="data">
                    <div v-html="dateTimeFormat(data.item.date_order)"></div>
                  </template>

                  <template v-slot:cell(delivery_date)="data">
                    <div v-html="dateFormat(data.item.delivery_date)"></div>
                  </template>

                  <template v-slot:cell(request_date)="data">
                    <div v-html="dateTimeFormat(data.item.request_date)"></div>
                  </template>

                  <template v-slot:cell(attendance_date)="data">
                    <div v-html="dateFormat(data.item.attendance_date)"></div>
                  </template>

                  <template v-slot:cell(expired_date)="data">
                    <div v-html="dateFormat(data.item.expired_date)"></div>
                  </template>

                  <template v-slot:cell(messages)="data">
                    <div v-html="data.item.messages"></div>
                  </template>

                  <template v-slot:cell(total_price_plan)="data">
                    <div v-html="'Rp. ' + formatPrice(data.item.total_price_plan)"></div>
                  </template>

                  <template v-slot:cell(salary)="data">
                    <div v-html="'Rp. ' + formatPrice(data.item.salary)"></div>
                  </template>

                  <template v-slot:cell(total_price_actual)="data">
                    <div
                      v-html="'Rp. ' + formatPrice(data.item.total_price_actual)"
                    ></div>
                  </template>

                  <template v-slot:cell(total_price_retur)="data">
                    <div v-html="'Rp. ' + formatPrice(data.item.total_price_retur)"></div>
                  </template>

                  <template v-slot:cell(amount)="data">
                    <div v-html="'Rp. ' + formatPrice(data.item.amount)"></div>
                  </template>

                  <template v-slot:cell(price)="data">
                    <div v-html="'Rp. ' + formatPrice(data.item.price)"></div>
                  </template>

                  <template v-slot:cell(fee)="data">
                    <div v-html="'Rp. ' + formatPrice(data.item.fee)"></div>
                  </template>

                  <template v-slot:cell(status)="data">
                    <b-badge :variant="getBadge(data.item.status)">{{
                      data.item.status
                    }}</b-badge>
                  </template>

                  <template v-slot:cell(level_access)="data">
                    <div v-if="data.item.level === '1'">Level Akses Manager</div>
                    <div v-if="data.item.level === '2'">Level Akses SPV</div>
                    <div v-if="data.item.level === '3'">Level Akses Staff</div>
                  </template>

                  <template v-slot:cell(employee_profile)="data">
                    <div>
                      <div>
                        {{ data.item.nik + " - " + data.item.name }}
                        <small v-if="data.item.surename !== null"
                          >({{ data.item.surename }})</small
                        >
                        <label
                          v-if="data.item.status === '6'"
                          class="badge badge-danger"
                          >{{ data.item.status_employee }}</label
                        >
                        <label
                          v-else-if="data.item.status === '1'"
                          class="badge badge-primary"
                          >{{ data.item.status_employee }}</label
                        >
                        <label v-else class="badge badge-warning">{{
                          data.item.status_employee
                        }}</label>
                      </div>
                      <span>
                        <small>
                          <i class="fa fa-calendar" /> :
                          <span v-html="dateFormat(data.item.start_join)"></span>
                          <span v-if="data.item.end_date !== null">
                            &nbsp;-
                            <span v-html="dateFormat(data.item.end_date)"></span>
                          </span>
                        </small>
                      </span>
                      <div>
                        <small>
                          <i class="fa fa-mobile" style="margin: 0 6px 0 0" /> :
                          <span v-html="data.item.mobile_phone"></span>
                        </small>
                      </div>
                    </div>
                  </template>

                  <template v-slot:cell(employee_bank_profile)="data">
                    <div>
                      <div>{{ data.item.name }}</div>
                      <small>
                        <div>
                          <i class="fa fa-bank" /> :
                          <span
                            >{{ data.item.bank_account_number }} -
                            {{ data.item.bank_name }}</span
                          >
                        </div>
                      </small>
                    </div>
                  </template>

                  <template v-slot:cell(customer_detail)="data">
                    <div>
                        <div>{{ data.item.name }}</div>
                        <div>
                          <i class="fa fa-group" /> : {{ data.item.customer_group_name }} /
                          <label v-if="data.item.lng !== null && data.item.lat !== null">
                            <a :href="'https://www.google.com/maps?q='+data.item.lat+','+data.item.lng" target="_blank" variant="ghost-primary">
                              <i class="fa fa-globe" />
                            </a>
                          </label>
                          <small v-if="data.item.lng == null || data.item.lat === null">(Lokasi belum ada)</small>
                        </div>
                        <div>
                          <i class="fa fa-phone" /> 1 : {{ (data.item.mobile_phone !== "") ? data.item.mobile_phone : "-" }}
                        </div>
                        <div>
                          <i class="fa fa-phone" /> 2 : {{ (data.item.mobile_phone2 !== "") ? data.item.mobile_phone2 : "-"}}
                        </div>
                        <div>
                          <i class="fa fa-phone" /> 3 : {{ (data.item.mobile_phone3 !== "") ? data.item.mobile_phone3 : "-"}}
                        </div>
                      </div>
                  </template>

              <template v-slot:cell(dc_name)="data">
                  <div>
                      <div>{{ data.item.name }}</div>
                      <div>
                        <small v-if="data.item.status === '1'" class="badge badge-info">
                          Active
                        </small>
                         <small v-else class="badge badge-warning">
                          Not Active
                        </small>
                      </div>
                    </div>
                </template>

                  <template v-slot:cell(show_detail)="data">
                    <b-button
                      type="button"
                      @click="showDetail($event, data)"
                      size="sm"
                      variant="primary"
                      title="Show this data"
                    >
                      <i class="cui-note icons"></i>
                    </b-button>
                  </template>

                  <template v-slot:cell(action)="data">
                    <b-button
                      v-if="redirectDetail && editButton"
                      type="button"
                      @click="goToDetail(data.item)"
                      size="sm"
                      variant="primary"
                      title="Go To detail"
                    >
                      <i class="cui-note icons"></i>
                    </b-button>
                    <b-button
                      v-else-if="!redirectDetail && editButton"
                      type="button"
                      @click="editForm(data.item)"
                      size="sm"
                      variant="primary"
                      title="Edit this data"
                    >
                      <i class="cui-note icons"></i> </b-button
                    >&nbsp;
                    <b-button
                      v-if="removeButton"
                      type="button"
                      size="sm"
                      variant="danger"
                      @click="removeForm(data.item)"
                      title="Remove this data"
                    >
                      <i class="cui-circle-x icons"></i> </b-button
                    >

                    <template v-if="customButtonDetail">
                      &nbsp;
                      <b-button
                        v-if="customButtonDetail"
                        type="button"
                        @click="goToDetail(data.item)"
                        size="sm"
                        variant="primary"
                        title="Go To detail"
                      >
                        <i class="cui-layers icons"></i>
                      </b-button>&nbsp;
                      <b-button
                       v-if="refreshLogs"
                        type="button"
                        @click="refreshSchedule(data.item)"
                        size="sm"
                        variant="warning"
                        title="Go To detail"
                      >
                        <i class="fa fa-refresh"></i>
                      </b-button>
                    </template>
                  </template>

                  <template v-slot:cell(action_spkb)="data">
                    <b-button
                      v-if="redirectDetail && editButton"
                      type="button"
                      @click="goToDetail(data.item)"
                      size="sm"
                      variant="primary"
                      title="Go To detail"
                    >
                      <i class="cui-note icons"></i> </b-button
                    >&nbsp;
                    <b-button
                      v-if="data.item.penanggung_jawab_faktur !== null"
                      type="button"
                      @click="print_surat_jalan(data)"
                      size="sm"
                      variant="info"
                      title="Print Surat Jalan"
                    >
                      <i class="fa fa-print"></i>
                    </b-button>
                    <!-- <div>
                      <a style="cursor:pointer;" @click="download_file(data)">
                        <i class="fa fa-cloud-download"></i>
                        Surat Jalan
                      </a>
                    </div>-->
                  </template>


                  <template v-slot:cell(action_retur)="data">
                    <b-button
                      v-if="redirectDetail && editButton"
                      type="button"
                      @click="goToDetail(data.item)"
                      size="sm"
                      variant="primary"
                      title="Go To detail"
                    >
                      <i class="cui-note icons"></i>
                    </b-button>
                    <b-button
                      v-else-if="!redirectDetail && editButton"
                      type="button"
                      @click="editForm(data.item)"
                      size="sm"
                      variant="primary"
                      title="Edit this data"
                    >
                      <i class="cui-note icons"></i> </b-button
                    >&nbsp;
                    <b-button
                      type="button"
                      size="sm"
                      variant="info"
                      title="Bypass"
                    >
                      <i class="cui-circle-x icons"></i> </b-button
                    >&nbsp;
                   
                  </template>

             
                </b-table>
                <nav v-if="!loading">
                  <b-pagination
                    v-if="pagination"
                    align="right"
                    size="sm"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    prev-text="Prev"
                    next-text="Next"
                    first-text="First"
                    last-text="Last"
                  />
                </nav>
              </div>

              <div v-else>
                <loading></loading>
              </div>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>

    <b-col v-else-if="tableDetail">
      <b-row>
        <b-col lg="12">
          <div v-if="!loading">
            <b-row>
              <b-col v-if="showAddButton">
                <b-button
                  size="sm"
                  v-on:click.prevent="addForm($event.target)"
                  variant="stack-overflow"
                  style="margin-bottom: 10px"
                  class="mr-1 btn-brand float-right"
                >
                  <i class="fa fa-plus"></i>
                  <span>{{ addButton }}</span>
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col v-if="filterTableOnly">
                <b-form id="filterForm">
                  <b-row>
                    <b-col sm="3">
                      <b-form-group>
                        <b-form-input
                          v-model="filter"
                          placeholder="Searching"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-form>
              </b-col>
            </b-row>

            <b-table
              :filter="filter"
              :dark="dark"
              :hover="hover"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              responsive="sm"
              :items="items"
              :fields="captions"
              head-variant="light"
              :current-page="currentPage"
              :per-page="perPage"
              :show-empty="true"
              :redirect-detail="redirectDetail"
            >
              <template v-slot:cell(price_plan)="data">
                <div v-html="formatPrice(data.item.price_plan)"></div>
              </template>

              <template v-slot:cell(attendance_history_date)="data">
                <div v-html="dateTimeFormat(data.item.attendance_history_date)"></div>
              </template>

              <template v-slot:cell(plan_delivery_order)="data">
                <div v-html="dateFormat(data.item.plan_delivery_order)"></div>
              </template>

              <template v-slot:cell(date_order)="data">
                <div v-html="dateTimeFormat(data.item.date_order)"></div>
              </template>

              <template v-slot:cell(date_inserted)="data">
                <div v-html="dateTimeFormat(data.item.date_inserted)"></div>
              </template>

              <template v-slot:cell(process_time)="data">
                <div v-html="dateTimeFormat(data.item.process_time)"></div>
              </template>

              <template v-slot:cell(request_date)="data">
                <div v-html="dateTimeFormat(data.item.request_date)"></div>
              </template>

              <template v-slot:cell(date_updated)="data">
                <div v-html="dateTimeFormat(data.item.date_updated)"></div>
              </template>

              <template v-slot:cell(total_price_plan)="data">
                <div v-html="formatPrice(data.item.total_price_plan)"></div>
              </template>

              <template v-slot:cell(price)="data">
                <div v-html="'Rp. ' + formatPrice(data.item.price)"></div>
              </template>

              <template v-slot:cell(amount)="data">
                <div v-html="'Rp. ' + formatPrice(data.item.amount)"></div>
              </template>

              <template v-slot:cell(fee)="data">
                <div v-html="'Rp. ' + formatPrice(data.item.fee)"></div>
              </template>

              <template v-slot:cell(placement_date)="data">
                <div v-html="dateFormat(data.item.placement_date)"></div>
              </template>

              <template v-slot:cell(messages)="data">
                <div v-html="data.item.messages"></div>
              </template>

              <template v-slot:cell(placement_date_alias)="data">
                <div v-html="dateFormat(data.item.placement_date_alias)"></div>
              </template>

              <template v-slot:cell(expired_date)="data">
                <div v-html="dateFormat(data.item.expired_date)"></div>
              </template>

              <template v-slot:cell(attendance_date)="data">
                <div v-html="dateFormat(data.item.attendance_date)"></div>
              </template>
              
              <template v-slot:cell(salary)="data">
                <div v-html="'Rp. ' + formatPrice(data.item.salary)"></div>
              </template>

              <template v-slot:cell(return_date)="data">
                <div v-html="dateFormat(data.item.return_date)"></div>
              </template>

              <template v-slot:cell(last_order_date)="data">
                <div v-if="data.item.last_order_date !== null" v-html="dateFormat(data.item.last_order_date)"></div>
                <div v-else v-html="'Belum Pernah Order'"></div>
              </template>


               <template v-slot:cell(customer_detail)="data">
                  <div>
                      <div>{{ data.item.name }}</div>
                      <div>
                        <i class="fa fa-group" /> : {{ data.item.customer_group_name }} /
                        <label v-if="data.item.lng !== null && data.item.lat !== null">
                          <a :href="'https://www.google.com/maps?q='+data.item.lat+','+data.item.lng" target="_blank" variant="ghost-primary">
                            <i class="fa fa-globe" />
                          </a>
                        </label>
                        <small v-if="data.item.lng == null || data.item.lat === null">(Lokasi belum ada)</small>
                      </div>
                      <div>
                        <i class="fa fa-phone" /> 1 : {{ (data.item.mobile_phone !== "") ? data.item.mobile_phone : "-" }}
                      </div>
                      <div>
                        <i class="fa fa-phone" /> 2 : {{ (data.item.mobile_phone2 !== "") ? data.item.mobile_phone2 : "-"}}
                      </div>
                      <div>
                        <i class="fa fa-phone" /> 3 : {{ (data.item.mobile_phone3 !== "") ? data.item.mobile_phone3 : "-"}}
                      </div>
                    </div>
                </template>

              <template v-slot:cell(contract_number_download)="data">
                <div>
                  <a style="cursor: pointer" @click="download_file(data)">
                    <i class="fa fa-cloud-download"></i>
                    {{ data.item.contract_number }}
                  </a>
                </div>
              </template>

                <template v-slot:cell(contract_number_download_alter)="data">
                <div>
                  <a style="cursor: pointer" @click="download_file_alter(data)">
                    <i class="fa fa-cloud-download"></i>
                    {{ data.item.contract_number_alias}}
                  </a>
                </div>
              </template>

              <template v-slot:cell(contract_number_return_download)="data">
                <div>
                  <a
                    style="cursor: pointer"
                    target="_blank"
                    :href="
                      axios.defaults.baseURL +
                      'web/export_pdf/assets/generate_return_asset/' +
                      data.item.customer_id +
                      '/' +
                      data.item.id +
                      '/'
                    "
                  >
                    <i class="fa fa-cloud-download"></i>
                    {{ data.item.contract_number }}
                  </a>
                </div>
              </template>

              <template v-slot:cell(document_name_preview)="data">
                  <b-button
                    type="button"
                    size="sm"
                    variant="primary"
                    @click="goToPreviewImage(data.item.file, data.item.document_type_id)"
                  > <i class="fa fa-search"></i>
                  </b-button>
                  {{ data.item.name }}

              </template>

              <template v-slot:cell(action)="data">
                <b-button
                  v-if="redirectDetail && editButton"
                  type="button"
                  @click="goToDetail(data.item)"
                  size="sm"
                  variant="primary"
                  title="Go To detail"
                >
                  <i class="cui-note icons"></i>
                </b-button>
                <b-button
                  v-else-if="!redirectDetail && editButton"
                  type="button"
                  @click="editForm(data.item)"
                  size="sm"
                  variant="primary"
                  title="Edit this data"
                >
                  <i class="cui-note icons"></i> </b-button
                >&nbsp;
                <b-button
                  v-if="removeButton"
                  type="button"
                  size="sm"
                  variant="danger"
                  title="Remove this data"
                  @click="removeForm(data.item)"
                >
                  <i class="cui-circle-x icons"></i> </b-button
                >&nbsp;
                <b-button
                  v-if="customButtonDetail"
                  type="button"
                  @click="goToDetail(data.item)"
                  size="sm"
                  variant="primary"
                  title="Go To detail"
                >
                  <i class="cui-layers icons"></i>
                </b-button>
              </template>

              <template v-slot:cell(action_retur)="data">
                    <b-button
                      v-if="redirectDetail && editButton"
                      type="button"
                      @click="goToDetail(data.item)"
                      size="sm"
                      variant="primary"
                      title="Go To detail"
                    >
                      <i class="cui-note icons"></i>
                    </b-button>
                    <b-button
                      v-else-if="!redirectDetail && editButton"
                      type="button"
                      @click="editForm(data.item)"
                      size="sm"
                      variant="primary"
                      title="Edit this data"
                    >
                      <i class="cui-note icons"></i> </b-button
                    >&nbsp;
                    <b-button
                      type="button"
                      size="sm"
                      variant="info"
                      title="Bypass"
                    >
                      <i class="cui-circle-x icons"></i> </b-button
                    >&nbsp;
                   
                  </template>

                  <template v-slot:cell(action_purchase_price)="data">
                    <b-button
                      v-if="data.item.flag === '1'"
                      type="button"
                      @click="editForm(data.item)"
                      size="sm"
                      variant="primary"
                      title="Go To detail"
                    >
                      <i class="cui-note icons"></i>
                    </b-button>
                    
                  </template>
            </b-table>
            <nav v-if="!loading">
              <b-pagination
                v-if="pagination"
                align="right"
                size="sm"
                :total-rows="totalRows"
                :per-page="perPage"
                v-model="currentPage"
                prev-text="Prev"
                next-text="Next"
                first-text="First"
                last-text="Last"
              />
            </nav>
          </div>

          <div v-else>
            <loading></loading>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
import * as moment from "moment";
import loading from "@/templates/Loading.vue";

export default {
  name: "global-table",
  inheritAttrs: false,
  components: { loading },
  props: {
    caption: {
      type: String,
      default: "Table",
    },
    addButton: {
      type: String,
      default: "",
    },
    addExcellButton: {
      type: String,
      default: "",
    },
    hover: {
      type: Boolean,
      default: false,
    },
    striped: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: Boolean,
      default: true,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    redirectDetail: {
      type: Boolean,
      default: true,
    },
    showAddButton: {
      type: Boolean,
      default: true,
    },
    uploadByExcell: {
      type: Boolean,
      default: false,
    },
    generateAutoSpkb: {
      type: Boolean,
      default: false,
    },
    removeButton: {
      type: Boolean,
      default: false,
    },
    editButton: {
      type: Boolean,
      default: true,
    },
    tableData: {
      type: [Array, Object],
      default: () => [],
    },
    // filter: {
    //   type: String,
    //   default: ""
    // },
    fields: {
      type: [Array, Object],
      default: () => [],
    },
    perPage: {
      type: Number,
      default: 5,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    tableDetail: {
      type: Boolean,
      default: false,
    },
    filterTableOnly: {
      type: Boolean,
      default: false,
    },
    idModals: {
      type: String,
      default: "addModals",
    },
    idModalsByExcell: {
      type: String,
      default: "addModalsByExcell",
    },
    customVariableId: {
      type: String,
      default: "id",
    },
    customButtonDetail: {
      type: Boolean,
      default: false,
    },
    refreshLogs: {
      type: Boolean,
      default: true,
    },
  },
  data: () => {
    return {
      myData: [],
      currentPage: 1,
      filterTotalRows: 0,
      filter: null,
    };
  },
  computed: {
    items: function () {
      const items = this.tableData;
      return Array.isArray(items) ? items : Object.values(items);
    },
    totalRows: function () {
      if (this.filter !== null) {
        return this.filterTotalRows;
      } else {
        return this.getRowCount();
      }
    },
    captions: function () {
      return this.fields;
    },
  },
  watch: {
    $route(to, from) {
      //console.log(to)
      //console.log(from)
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init: function () {
      this.myData = this.items;
      //this.totalRows = this.getRowCount();
    },
    getBadge: function (status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
        ? "secondary"
        : status === "Pending"
        ? "warning"
        : status === "Banned"
        ? "danger"
        : "primary";
    },
    goToDetail: function (row) {
      let path = this.$route.path.split("/");
      //console.log(path)
      //
      /*
         this.$router.push({
          path: (path[1] === 'master') ? path[2]+'/detail/'+row.id : 'detail/'+row.id
        })
         */
         console.log( path[2])
      this.$router.push({
        path: path.hasOwnProperty("2")
          ? path[2] + "/detail/" + row[this.customVariableId]
          : "detail/" + row[this.customVariableId],
      });
    },
    editForm: function (row) {
      this.$emit("editForm", row);
      this.$emit("isEdit", true);
      this.$root.$emit("bv::show::modal", this.idModals);
    },
    addForm: function (button) {
      this.$emit("isEdit", false);
      this.$emit("resetForm");
      this.$root.$emit("bv::show::modal", this.idModals, button);
    },
    addFormExcell: function (button) {
      this.$emit("isEdit", false);
      this.$emit("resetFormUploadForm");
      this.$root.$emit("bv::show::modal", this.idModalsByExcell, button);
    },
    generateSPKB: function (button) {
      this.$emit("isEdit", false);
      this.$emit("generateAutoSPKB");
    },
    refreshSchedule: function(row) {
      this.$emit("isEdit", false);
      this.$emit("refreshSchedule", row);
    },
    removeForm: function (row) {
      this.$emit("removeForm", row);
    },
    close: function () {
      //console.log("aaa");
    },
    getRowCount: function () {
      return this.items.length;
    },
    dateFormat: function (date) {
      return date === null ? "" : moment(date).format("DD MMM YYYY");
    },
    dateTimeFormat: function (date) {
      return moment(date).format("DD MMM YYYY HH:mm:ss");
    },
    showDetail: function (button, row) {
      this.$emit("showDetail", row);
      this.$root.$emit("bv::show::modal", "openDetail", button);
    },
    goToPreviewImage: function(row, doctype_id) {
      this.$emit("goToPreviewImage", {data: row, doctype_id: doctype_id});
      //this.$root.$emit("bv::show::modal", "openPreviewImage", button);
    },
    onFiltered(filteredItems) {
      //this.totalRows(filteredItems)
      this.filterTotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    dateFormatRange: function (date) {
      let temp = "";
      if (date !== "") {
        for (var d in date) {
          temp +=
            temp === ""
              ? moment(date[d]).format("DD MMM YYYY")
              : ", " + moment(date[d]).format("DD MMM YYYY");
        }
        return temp;
      } else {
        return "";
      }
    },
    download_file: function (data, path = "generate_customer_asset") {
      if(['58','59'].includes(data.item.customer_group)) {
        path = 'generate_customer_asset_afull';
      } else if (['60'].includes(data.item.customer_group)) {
        path = 'generate_customer_asset_coko';
      }
      
      window.open(
        axios.defaults.baseURL +
          "web/export_pdf/assets/" +
          path +
          "/" +
          data.item.customer_id +
          "/" +
          data.item.id +
          "/"
      );
    },

    download_file_alter: function (data, path = "generate_customer_asset") {
      window.open(
        axios.defaults.baseURL +
          "web/export_pdf/assets_alter/" +
          path +
          "/" +
          data.item.customer_id +
          "/" +
          data.item.id +
          "/"
      );
    },
    download_document: function (path, file) {
      return axios.defaults.upload_path + path + file;
    },
    print_surat_jalan: function (data) {
      if (data.item.delivery_date !== null) {
        window.open(
          axios.defaults.baseURL +
            "web/export_pdf/surat_jalan/generate_surat_jalan/" +
            data.item.spkb_number +
            "/"
        );
      } else {
        alert("Harap masukkan tanggal pengiriman");
      }
    },
  },
};
</script>
